var LazyLoad = require("vanilla-lazyload");



var lazyLoadOptions = {
	elements_selector: ".lazy",
	to_webp: true,
	skip_invisible:false,
	threshold: 50
};

var createLazyLoadInstance = function() {
	return new LazyLoad(lazyLoadOptions);
};

var lazyLoadInit = function()  {
	document.addEventListener("DOMContentLoaded", createLazyLoadInstance);
};

module.exports = lazyLoadInit;


/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/lazyload-init.js
 ** module id = 72
 ** module chunks = 24
 **/